type LoaderProps = {
  size: 'small' | 'medium' | 'large'
  message?: string
}

export default function Loader({ size, message }: LoaderProps): JSX.Element {
  const sizeMap = {
    small: 'h-[24px] w-[24px]',
    medium: 'h-[48px] w-[48px]',
    large: 'h-[72px] w-[72px]',
  }

  const sizeClass = sizeMap[size]

  return (
    <div role="status" className="flex flex-col items-center justify-center text-primary">
      <svg className={`${sizeClass} animate-spin`} viewBox="0 0 100 100">
        <circle
          fill="none"
          strokeWidth="10"
          className="stroke-current opacity-10"
          cx="50"
          cy="50"
          r="40"
        />
        <circle
          fill="none"
          strokeWidth="10"
          className="stroke-current opacity-70"
          strokeDasharray="250"
          strokeDashoffset="210"
          cx="50"
          cy="50"
          r="40"
        />
      </svg>
      {message ? (
        <span className="mt-s block text-20 font-bold text-black">{message}</span>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </div>
  )
}
